export default {
  listItemSubtextColor: 'token.text-default',
  listItemTitleColor: 'token.text-default',
};
